import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ZodiacWheel, CosmicBackground, Navigation } from './components';
import { HomePage, ContactPage, ServicesPage, AboutPage } from './pages';
import './index.css';

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <div className="relative min-h-screen overflow-x-hidden">
        {/* Fixed Cosmic Background Layer */}
        <CosmicBackground />
        
        {/* Fixed Zodiac Wheel Layer */}
        <ZodiacWheel />
        
        {/* Navigation Layer */}
        <Navigation />
        
        {/* Main Content Layer */}
        <main className="relative z-10">
          <AnimatedRoutes />
        </main>
      </div>
    </Router>
  );
}

export default App;
